import axios from "axios";
import { router } from "./router";
import { store } from "./store";
import { appUrl } from "./vars";
import { apiUrl } from "./vars";

export default {


  signin(parent, data) {
    console.log("on auth");
	  console.debug(data.email)
    axios
      .post(apiUrl + "/auth/login", data)
      .then((response, context = parent) => {
        if (response.data.token) {
          context.error = null;
          let d = "home";
          let t = response.data.token.split(".");
          let i = btoa(t[0])
            .split("")
            .reverse()
            .join("");
          let w = btoa(response.statusText);
          let v = btoa(response.message);
          let u = btoa(t[1])
            .split("")
            .reverse()
            .join("");
          let k = btoa(response.data.status);
          let r = btoa(t[2])
            .split("")
            .reverse()
            .join("");
          let x = btoa(d);

          window.location =
            appUrl +
            "/sso?gw328DK2=" +
            i +
            "&ADHXf2x3=" +
            w +
            "&xftBIGAC=" +
            v +
            "&BGxYZ4xu=" +
            u +
            "&PeIQ306e=" +
            k +
            "&o2d8IWFA=" +
            r +
            "&bPkIzKkT=" +
            x;
        }

        if (response.data.error) {
          context.error = response.data.error;
        }

	      if (response.data.disabled) {
		      context.disabled = response.data.disabled;
	      }
      })
      .catch((error, context = parent) => {
        console.error(error);

        switch (error.response.status) {
          case 500:
            context.error =
              "Erro no servidor. Favor tentar novamente mais tarde.";
            break;
          case 401:
            context.error = "O email ou password indicados não estão corretos.";
            break;
          default:
            context.error =
              "Erro " +
              error.response.status +
              ": " +
              error.response.statusText;
        }
      });
  },

  tokenSignin(token) {
    console.log("token signin", token.substr(0, 10));
    let d = "home";
    let t = token.split(".");
    let i = btoa(t[0])
      .split("")
      .reverse()
      .join("");
    let w = btoa(response.statusText);
    let v = btoa(response.message);
    let u = btoa(t[1])
      .split("")
      .reverse()
      .join("");
    let k = btoa(response.data.status);
    let r = btoa(t[2])
      .split("")
      .reverse()
      .join("");
    let x = btoa(d);

    window.location =
      appUrl +
      "/sso?gw328DK2=" +
      i +
      "&ADHXf2x3=" +
      w +
      "&xftBIGAC=" +
      v +
      "&BGxYZ4xu=" +
      u +
      "&PeIQ306e=" +
      k +
      "&o2d8IWFA=" +
      r +
      "&bPkIzKkT=" +
      x;
  },

  signout(context) {
    localStorage.removeItem("route");
    context.$store.commit("clearToken");
    context.$store.commit("clearUser");
    context.$store.commit("clearExpires");
    context.$router.push({
      name: "home"
    });
  }

};



// WEBPACK FOOTER //
// ./src/auth.js